module.exports = __webpack_public_path__ + "img/lpq_logo.d0fd7ff7.png";